import { inject, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HTTP_INTERCEPTORS,
  HttpInterceptorFn,
  HttpHandlerFn,
} from '@angular/common/http';
import { catchError, empty, Observable, switchMap, throwError } from 'rxjs';
import { AuthService } from '../service/auth.service';
import { Router } from '@angular/router';
import { User } from '@core/models/user';
import { jwtDecode } from 'jwt-decode';
import { CommonSharedService } from '@shared/services/common-shared.service';
import { HelpersService } from '@shared/services/helpers.service';
// @Injectable()
// export class JwtInterceptor implements HttpInterceptor {
//   constructor(private authenticationService: AuthService, private router: Router) { }
//   token: string="";
//   intercept(
//     request: HttpRequest<any>,
//     next: HttpHandler
//   ): Observable<HttpEvent<any>> {

//     // add authorization header with jwt token if available
//     const currentUser = this.authenticationService.currentUserValue;
//     if (currentUser && currentUser.token) {
//       request = request.clone({
//         setHeaders: {
//           Authorization: `Bearer ${currentUser.token}`,
//         },
//       });
//     }

//     return next.handle(request);
//   }

//   isTokenExpired(token: string): boolean {
//     try {
//       const decodedToken: any = jwtDecode(token);
//       const currentTime = Math.floor(Date.now() / 1000);
//       return decodedToken.exp < currentTime;
//     } catch (error) {
//       // Error decoding token
//       return true;
//     }
//   }

//   assignToken(res:any) {

//     const token_data: any = jwtDecode(res.access_token);

//     var roles = token_data?.realm_access?.roles ?? [];

//     var user: User = {
//       firstName: token_data.given_name,
//       lastName: token_data.family_name,
//       img: "",
//       id: token_data.sub,
//       password: "",
//       role: this.authenticationService.currentUserValue.role,
//       username: token_data.preferred_username,
//       name: token_data.name,
//       token: res.access_token,
//       email: token_data.email,
//       refresh_token: res.refresh_token
//     }

//     localStorage.setItem('currentUser', JSON.stringify(user));

//     this.authenticationService.currentUserSubject.next(user);

//   }

//   refreshToken(): Observable<any> {

//     return this.authenticationService.getRefreshToken();

//   }
// }

// export const jwtInterceptor: HttpInterceptorFn = (
//   req: HttpRequest<any>,
//   next: HttpHandlerFn
// ): Observable<HttpEvent<any>> => {
//   const authenticationService = inject(AuthService);
//   const commonSharedService = inject(CommonSharedService);
//   const router = inject(Router);
//   const authExcludeRoutes = [
//     '/authentication/signin',
//     '/authentication/forgot-password',
//   ];

//   const requestUrl = req.url;

//   if (requestUrl.includes('realm')) {
//     return next(req);
//   }


//   if (!localStorage.getItem('currentUser') && !req.url.includes('token')) {
//     if (!authExcludeRoutes.includes(router.url)) {
//       router.navigateByUrl('authentication/signin');
//     }
//   }
//   var currentUserJson = localStorage.getItem('currentUser');
//   var currentUser: User = currentUserJson ? JSON.parse(currentUserJson) : null;
// console.log('currentUsertk',currentUser);

//   if (currentUser && currentUser.token) {
// console.log('currentUsertk',currentUser.token);
// console.log('currentUsertk',isTokenExpired(currentUser.token));

//     if (isTokenExpired(currentUser.token)) {

//       console.log('currentUsertk Token expired');	

//       if (currentUser.refresh_token && !isTokenExpired(currentUser.refresh_token)) {

//         authenticationService.setRefreshToken(currentUser.refresh_token);

//         console.log('Refreshing token');	
//         // router.navigateByUrl('authentication/signin');

//         authenticationService.getRefreshToken().subscribe((res) => {
// console.log('Refreshing token response',res);

//           currentUser =  authenticationService.HandleToken(currentUser);

//         authenticationService.setRefreshToken(res.refresh_token);

//           req = req.clone({
//             setHeaders: {
//               Authorization: `Bearer ${res.token}`,
//             },
//           });
//           return next(req);
//         },(error) => {
//           console.error('Error refreshing token:', error);

//           authenticationService.logout(); 


//         });
//       } else {
//         // router.navigateByUrl('authentication/signin');
//         authenticationService.logout();
//       }

//     }


//     req = req.clone({
//       setHeaders: {
//         Authorization: `Bearer ${currentUser.token}`,
//       },
//     });


//   } else {
//     if (!authExcludeRoutes.includes(router.url)) {
//       router.navigateByUrl('authentication/signin');
//     }
//   }

//   return next(req);
// };

export const jwtInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const authenticationService = inject(AuthService);
  const helperService = inject(HelpersService);
  const router = inject(Router);
  const authExcludeRoutes = [
    '/authentication/signin',
    '/authentication/forgot-password',
  ];

  const requestUrl = req.url;

  if (requestUrl.includes('realm')) {
    return next(req);
  }

  if (!localStorage.getItem('currentUser') && !req.url.includes('token')) {
    if (!authExcludeRoutes.includes(router.url)) {
      router.navigateByUrl('/authentication/signin');
    }
  }

  let currentUserJson = localStorage.getItem('currentUser');
  let currentUser = currentUserJson ? JSON.parse(currentUserJson) : null;
  authenticationService.setRefreshToken(currentUser.refresh_token);

  if (currentUser && currentUser.token) {

    if (isTokenExpired(currentUser.token)) {

      console.log('Token expired, attempting refresh');

      if (currentUser.refresh_token && !isTokenExpired(currentUser.refresh_token)) {

        return authenticationService.getRefreshToken().pipe(
          switchMap((res: any) => {
            console.log('Refresh token successful', res);

            authenticationService.HandleToken(res);
            authenticationService.setRefreshToken(res.refresh_token);

            req = req.clone({
              setHeaders: {
                Authorization: `Bearer ${res.access_token}`,
              },
            });

            return next(req);
          }),
          catchError((error) => {
         
             authenticationService.logout();

            // router.navigateByUrl('/authentication/signin');
            return throwError(() => error);
          })
        );
      } else {
        console.log('Refresh token expired or missing, logging out');
        authenticationService.logout();
        router.navigateByUrl('/authentication/signin');
      helperService.showErrorToast('Session expired');
        return throwError(() => new Error('Session expired'));
      }
    }

    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${currentUser.token}`,
      },
    });
  } else {
    if (!authExcludeRoutes.includes(router.url)) {
      router.navigateByUrl('/authentication/signin');
    }
  }

  return next(req);
};

export function isTokenExpired(token: string): boolean {
  try {
    const decodedToken: any = jwtDecode(token);
    const currentTime = Math.floor(Date.now() / 1000);
    return decodedToken.exp < currentTime;
  } catch (error) {
    return true;
  }
}

export function assignToken(res: any) {
  const authenticationService = inject(AuthService);

  const token_data: any = jwtDecode(res.access_token);
  const user: User = {
    firstName: token_data.given_name,
    lastName: token_data.family_name,
    img: '',
    id: token_data.sub,
    password: '',
    role: authenticationService.currentUserValue.role,
    username: token_data.preferred_username,
    name: token_data.name,
    token: res.access_token,
    email: token_data.email,
    refresh_token: res.refresh_token,
  };

  localStorage.setItem('currentUser', JSON.stringify(user));
  authenticationService.currentUserSubject.next(user);
}

export function refreshToken(): Observable<any> {
  const authenticationService = inject(AuthService);
  return authenticationService.getRefreshToken();
}
function isEmpty(obj: any) {
  return Object.keys(obj).length === 0;
}